//Get user session
const getSessionToken = () => {
    return localStorage?.getItem('auth_token');
}

// return true if user is logged in
const isLoggedIn = () => {
    if(getSessionToken() === '' || !getSessionToken())
        return false 
    return true;
}

//set user session
const setSessionToken = (token) => {
    return localStorage?.setItem('auth_token',token);
}

//Remove user session
const removeSessionToken = () => {
    localStorage?.removeItem('auth_token')
    localStorage?.removeItem('user')
}

//Set user if logged in
const setUser = (user) => {
    return localStorage?.setItem('user',JSON.stringify(user))
}

//Get user info if logged in
const getUser = () => {
    const user = localStorage?.getItem('user');
    
    if (user === 'undefined' || !user) {
        removeSessionToken();
        return {};
    }

    return {
        ...JSON.parse(user)
    }
}

//Redirect to login page if session expired
const redirectIfSessionExpired = (err, history) => {
    if (!err) return;
    
    if (err.status && err.status === 'Token is Expired') {
        removeSessionToken();
        history.push('/login');
    }
    removeSessionToken();
    history.push('/login');
}


export const Auth = {
    redirectIfSessionExpired,
    getUser,
    setUser,
    removeSessionToken,
    setSessionToken,
    isLoggedIn,
    getSessionToken

}

